export default __webpack_public_path__ + "images/b1cc2ff07df4d6743bd81ec60415bd25.svg";